// extracted by mini-css-extract-plugin
export default {"EventDetailsModal":"Styles_EventDetailsModal__HpX0X","Modal":"Styles_Modal__Bupuq","Body":"Styles_Body__yn61V","Footer":"Styles_Footer__YCIgo"};